import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import { TextField } from '@material-ui/core'
import YesNoButtons from '../form-components/yes-no-buttons'

const ExternalRegistrationUrl = () => {
  const { register, errors, control } = useFormContext()

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          Do you want to use PGA Coach to collect registrations?
        </Typography>
      </Box>
      <Controller
        name="isExternalRegistration"
        control={control}
        render={({ onChange, value }) => (
          <>
            <Box mb={9}>
              <YesNoButtons
                isYes={!value}
                setIsYes={newValue => onChange(!newValue)}
              />
            </Box>
            {value ? (
              <>
                <Container maxWidth="sm">
                  <Box mb={1}>
                    <Typography variant="h5" align="center">
                      Enter your registration URL
                    </Typography>
                  </Box>
                  <Box mb={6}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      align="center"
                    >
                      Your event will still be marketed on PGA.com/things-to-do
                      however, registrants will be redirected to the URL you
                      provide below.
                    </Typography>
                  </Box>
                  <FormControl
                    error={!!errors.externalRegistrationUrl}
                    variant="outlined"
                  >
                    <TextField
                      label="Enter registration URL"
                      name="externalRegistrationUrl"
                      inputRef={register}
                      error={!!errors?.externalRegistrationUrl}
                      helperText={errors?.externalRegistrationUrl?.message}
                    />
                  </FormControl>
                </Container>
              </>
            ) : null}
          </>
        )}
      ></Controller>
    </Box>
  )
}

export default ExternalRegistrationUrl
